import { render, staticRenderFns } from "./VisionNotEnabledModal.vue?vue&type=template&id=71d0b3e4&scoped=true&"
import script from "./VisionNotEnabledModal.vue?vue&type=script&lang=js&"
export * from "./VisionNotEnabledModal.vue?vue&type=script&lang=js&"
import style0 from "./VisionNotEnabledModal.vue?vue&type=style&index=0&id=71d0b3e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d0b3e4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCol,VDialog,VDivider,VIcon,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71d0b3e4')) {
      api.createRecord('71d0b3e4', component.options)
    } else {
      api.reload('71d0b3e4', component.options)
    }
    module.hot.accept("./VisionNotEnabledModal.vue?vue&type=template&id=71d0b3e4&scoped=true&", function () {
      api.rerender('71d0b3e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Vision/model/VisionNotEnabledModal.vue"
export default component.exports